import debounce from "lodash/debounce"
import { loadPage } from "app/components/explore/utils"
import VanillaFittty from "shared/scripts/vanilla_fittty"
import { loadApplets, loadMoreApplets } from "app/scripts/load_applets_list"

const ServiceTabs = async () => {
  const serviceTabsData = JSON.parse(document.querySelector("[data-service-tabs]")?.dataset?.serviceTabs || "{}")
  const {
    currentTab,
    discoverAppletsUrl,
    discoverMoreAppletsUrl,
    myAppletsUrl,
    signedIn,
  } = serviceTabsData
  const searchPopularAppletsUrl = document.querySelector("section.popular-applets")?.dataset["searchpopularappletsurl"]
  const discoverAppletsContainer = document.querySelector(".discover_applets")
  const searchAppletsContainer = document.querySelector(".discover_applets_search")

  // Signed-out users load Applets in backend and it's cached. It doesn't have my Applets.
  if (signedIn) {
    if (currentTab === "my_applets") {
      await loadApplets(myAppletsUrl, ".my_applets")
      await loadApplets(discoverAppletsUrl, ".discover_applets")
    } else {
      await loadApplets(discoverAppletsUrl, ".discover_applets")
      await loadApplets(myAppletsUrl, ".my_applets")
    }

    loadMoreApplets(discoverAppletsContainer, discoverMoreAppletsUrl)
  } else {
    loadMoreApplets(discoverAppletsContainer, discoverMoreAppletsUrl)
  }

  const fetchMoreSearchResult = (event: Event, term: string) => {
    event.target.parentElement.remove()
    searchAppletsContainer?.classList.add("loading")

    loadPage(`${searchPopularAppletsUrl}?term=${term}&page=rest`).then(html => {
      searchAppletsContainer?.classList.remove("loading")
      searchAppletsContainer?.querySelector(".web-applet-cards")?.insertAdjacentHTML("beforeend", html)
      VanillaFittty(searchAppletsContainer)
    })
  }

  const fetchSearchResult = (term: string) => {
    loadPage(`${searchPopularAppletsUrl}?term=${term}`).then(html => {
      searchAppletsContainer?.classList.remove("loading")
      searchAppletsContainer?.insertAdjacentHTML("afterbegin", html)
      VanillaFittty(searchAppletsContainer)

      const loadMoreSearchButton = searchAppletsContainer?.querySelector("#load-more-search-applets");
      loadMoreSearchButton?.addEventListener("click", event => fetchMoreSearchResult(event, term), { once: true })
    })
  }

  const debouncedFetchSearchResult = debounce(fetchSearchResult, 250)

  const cleanSearch = () => {
    discoverAppletsContainer?.classList.remove("hide")
    searchAppletsContainer?.classList.add("hide")
  }

  const searchWrapper = document.querySelector("#popular-applets-search")
  if (searchWrapper) {
    const searchInput = searchWrapper.querySelector("input")

    searchInput?.addEventListener("input", event => {
      const term = event.target.value

      if (!term) {
        cleanSearch()
      } else {
        discoverAppletsContainer?.classList.add("hide")
        searchAppletsContainer?.classList.remove("hide")
        searchAppletsContainer?.classList.add("loading")
        searchAppletsContainer?.querySelectorAll(".search-result")?.forEach(el => el.remove()); // Remove previous search content

        debouncedFetchSearchResult(encodeURIComponent(term.toLowerCase()))
      }
    })

    window.addEventListener(`clean-search:${searchWrapper.id}`, cleanSearch)
  }
}

export default ServiceTabs
